export const LOGIN_USER_DETAIL_UPDATE = "LOGIN_USER_DETAIL_UPDATE";
export const LOGOUT_USER_DETAIL = "LOGOUT_USER_DETAIL";
